<h2 mat-dialog-title>Stall Layout</h2>
<form [formGroup]="addUserForm" (ngSubmit)="onFormSubmit()">
    <div mat-dialog-content class="content">

        <div class="row">
            <div class="col-12">
                <div *ngIf="!isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall_layout/{{this.imagePath}}"
                        style="width: 100%;height: 100%;border-radius: 10px;">
                </div>
                <div *ngIf="isOld1">
                    <img src="https://aieventzo.com/upload/{{event_id}}/stall_layout/{{image_name}}"
                        style="width: 100%;height: 100%;border-radius: 10px;">
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-12">
                <mat-label>Select Image</mat-label>
                <div class="input-group">
                    <input type="file" class="form-control" id="inputGroupFile01" #file accept='image/*'
                        id="exampleInputFile" (change)="previewpimage(file.files)">
                </div>
            </div>
        </div>


        <div mat-dialog-actions class="action" align="end">
            <button mat-raised-button type="button" color="warn" [mat-dialog-close]="false">Cancel</button>
            <button mat-raised-button type="submit" color="primary">Save</button>
        </div>
    </div>
</form>